export const stationTypes = [
  { id: 1, typeName: "전체" },
  { id: 2, typeName: "aws" },
  { id: 3, typeName: "asos" },
  { id: 4, typeName: "rda" },
  { id: 5, typeName: "fireblight" },
];
